import { render, staticRenderFns } from "./Randomizer.vue?vue&type=template&id=b529db3c&"
import script from "./Randomizer.vue?vue&type=script&lang=js&"
export * from "./Randomizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports